import TemplateNames from './TemplateNames';

export default {
  title: 'Messaggi inviati',
  columns: {
    recipient: 'Destinatario',
    template: 'Template',
    status: 'Stato',
    opened: 'Aperto',
    clicked: 'Cliccato',
    sent_at: 'Inviato il',
  },
  labels: {
    empty_list: 'Nessun messaggio inviato',
    load_failed: "Impossibile caricare i messaggi inviati. Ricarica la pagina o contatta l'assistenza.",
    yes: 'Sì',
    no: 'No',
    clicked_at: 'Cliccato il: {{date}}',
    opened_at: 'Aperto il: {{date}}',
  },
  message_statuses: {
    sent: 'Inviato',
    delivered: 'Consegnato',
    failed: 'Non riuscito',
  },
  template_names: TemplateNames,
  toasts: {
    failed_to_load_data: 'Caricamento dati non riuscito',
  },
};
